import type { IconData } from '@stacksjs/iconify-core'

export const rw4x3: IconData = {
  "body": "<path fill=\"#20603d\" d=\"M0 0h640v480H0z\"/><path fill=\"#fad201\" d=\"M0 0h640v360H0z\"/><path fill=\"#00a1de\" d=\"M0 0h640v240H0z\"/><g transform=\"translate(511 125.4)scale(.66667)\"><g id=\"SVGSMboovNs\"><path id=\"SVGwxHmebKq\" fill=\"#e5be01\" d=\"M116.1 0L35.7 4.7l76.4 25.4l-78.8-16.3L100.6 58l-72-36.2L82 82.1L21.9 28.6l36.2 72l-44.3-67.3L30 112L4.7 35.7L0 116.1L-1-1z\"/><use width=\"100%\" height=\"100%\" href=\"#SVGwxHmebKq\" transform=\"scale(1 -1)\"/></g><use width=\"100%\" height=\"100%\" href=\"#SVGSMboovNs\" transform=\"scale(-1 1)\"/><circle r=\"34.3\" fill=\"#e5be01\" stroke=\"#00a1de\" stroke-width=\"3.4\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default rw4x3
